"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotlightEligibilityConfigDto = exports.SpotlightEligibilityRulesDto = exports.SpotlightEligibilityFlagRuleDto = exports.SpotlightEligibilityCountRuleDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class SpotlightEligibilityCountRuleDto {}
exports.SpotlightEligibilityCountRuleDto = SpotlightEligibilityCountRuleDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], SpotlightEligibilityCountRuleDto.prototype, "enabled", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  minimum: 0
}), __metadata("design:type", Number)], SpotlightEligibilityCountRuleDto.prototype, "minCount", void 0);
class SpotlightEligibilityFlagRuleDto {}
exports.SpotlightEligibilityFlagRuleDto = SpotlightEligibilityFlagRuleDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], SpotlightEligibilityFlagRuleDto.prototype, "enabled", void 0);
class SpotlightEligibilityRulesDto {}
exports.SpotlightEligibilityRulesDto = SpotlightEligibilityRulesDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightEligibilityCountRuleDto
}), __metadata("design:type", SpotlightEligibilityCountRuleDto)], SpotlightEligibilityRulesDto.prototype, "checkedIns", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightEligibilityCountRuleDto
}), __metadata("design:type", SpotlightEligibilityCountRuleDto)], SpotlightEligibilityRulesDto.prototype, "recentViews", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightEligibilityFlagRuleDto
}), __metadata("design:type", SpotlightEligibilityFlagRuleDto)], SpotlightEligibilityRulesDto.prototype, "hasLogo", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightEligibilityFlagRuleDto
}), __metadata("design:type", SpotlightEligibilityFlagRuleDto)], SpotlightEligibilityRulesDto.prototype, "activeSpecial", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightEligibilityFlagRuleDto
}), __metadata("design:type", SpotlightEligibilityFlagRuleDto)], SpotlightEligibilityRulesDto.prototype, "sponsored", void 0);
class SpotlightEligibilityConfigDto {}
exports.SpotlightEligibilityConfigDto = SpotlightEligibilityConfigDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Bounding-box search radius in degrees from the user location.'
}), __metadata("design:type", Number)], SpotlightEligibilityConfigDto.prototype, "searchRadiusDegrees", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'How far back peeks count as recent viewers for eligibility and interestedUsers.'
}), __metadata("design:type", Number)], SpotlightEligibilityConfigDto.prototype, "recentViewsWindowDays", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightEligibilityRulesDto
}), __metadata("design:type", SpotlightEligibilityRulesDto)], SpotlightEligibilityConfigDto.prototype, "rules", void 0);
//# sourceMappingURL=SpotlightEligibilityConfig.dto.js.map